import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adminapp-critical-error-model-absent',
  templateUrl: './critical-error-model-absent.component.html',
  styleUrls: ['./critical-error-model-absent.component.scss']
})
export class CriticalErrorModelAbsentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
